module.exports = {"en":{"modules":{"notifications":{"title":"Notifications","list":{"empty":"You have no notifications"}}}}}